import Navlink from "@/component/Navlink";
//import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import SVG from "react-inlinesvg";

import styles from "./desktopNavbar.module.scss";
import textLanguage from "@/constants/textLanguage";
import siteInfo from "@/constants/siteInfo";
import sendGAEvent from "@/utils/gaEvent";
import { MasterConfigContext } from "@/context/MasterConfigContext";

const Navbar = ({ header_menu }) => {
  const stateMenus = header_menu?.find(
    (item) => item?.canonical_url == "/state-news"
  );

  const [searchText, setSearchText] = useState("");
  const router = useRouter();
  const isRajasthan = router?.asPath?.includes("/rajasthan");
  const isMadhya = router?.asPath?.includes("/madhya-pradesh");
  const isHR = router?.asPath?.includes("/haryana");
  const isBH = router?.asPath?.includes("/bihar");
  const isUP =
    router?.asPath?.includes("/uttar-pradesh") &&
    !router.asPath.includes("board-results");
  const isDL = router?.asPath?.includes("/delhi");
  const isCGT = router?.asPath?.includes("/chhattisgarh");
  const isUK = router?.asPath?.includes("/uttarakhand");
  const masterConfig = useContext(MasterConfigContext);
  const liveKeys = masterConfig["livetv_page"];
  const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
const isBiz= router?.asPath?.includes("/business");
  const handleSearch = () => {
    if (!searchText?.trim()?.length > 0) return;
    setSearchText("");
    let eventName = `view_search_results`;
    sendGAEvent({
      eventName: eventName,
      pageTitle: document?.title,
      pageLocation: window?.location?.href,
      searchQuery: searchText?.trim(),
    });
    window.location.href = `${process.env.NEXT_PUBLIC_WEBSITE_URL
      }/search/${encodeURIComponent(searchText?.trim())}`;
    // setSearchText("");
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && searchText?.trim()?.length > 0) {
      handleSearch();
    }
  };
  return (
    // <nav
    //   className={`top-0 bg-white shadow-sm lg:pl-4 md:pl-4 sm:pl-2 min-h-[4rem] relative`}
    // >
    <nav className={`top-0 w-full bg-white shadow-sm lg:pl-4 md:pl-4 sm:pl-2  min-h-[64px] relative`}
    // className="right-0 bg-white w-full  md:w-[98%] md:flex ms-5 divide-x divide-slate-300 min-h-[64px]"
    >
      <div className="w-full flex justify-between items-center py-2 h-16">
        <div
          className="shrink-0 min-w-[100px] md:w-[14.67%]"
          style={{ width: "auto" }}
        >
          <a
            href={

              (isMadhya
                ? "/madhya-pradesh"
                : isRajasthan
                  ? "/rajasthan"
                  : isHR
                    ? "/haryana"
                    : isBH
                      ? "/bihar"
                      : isUP
                        ? "/uttar-pradesh"
                        : isDL
                          ? "/delhi-news"
                          : isCGT
                            ? "/chhattisgarh"
                            : isUK
                              ? "/uttarakhand"
                              : isBiz
                                ? "/business"
                              : "/")
            }
            onClick={() => {
              let eventName = `TopBar-LogoClick`;
              sendGAEvent({
                eventName: eventName,
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <img
              src={
                isRajasthan
                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-2994.png"
                  : isMadhya
                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-3068.png"
                    : isHR
                      ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana_tak_light.png"
                      : isBH
                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_tak_light.png"
                        : isUP
                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/uptak_light.png"
                          : isDL
                            ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/delhi_tak_light.png"
                            : isCGT
                              ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ccg_logo.png"
                              : isUK
                                ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ut-2.png"
                                : isBiz
                                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/biz-horizontal.svg"
                                : siteInfo?.siteLogo
              }
              title={
                isMadhya
                  ? "MP Tak"
                  : isRajasthan
                    ? "Rajasthan Tak"
                    : isUP
                      ? "UP Tak"
                      : isHR
                        ? "Haryana Tak"
                        : isBH
                          ? "Bihar Tak"
                          : isDL
                            ? "Delhi Tak"
                            : isCGT
                              ? "Chhattisgarh Tak"
                              : isUK
                                ? "Uttarakhand Tak"
                                : isBiz ? "Biz Tak"
                                : siteInfo?.siteName
              }
              alt={
                isMadhya
                  ? "MP Tak"
                  : isRajasthan
                    ? "Rajasthan Tak"
                    : isUP
                      ? "UP Tak"
                      : isHR
                        ? "Haryana Tak"
                        : isBH
                          ? "Bihar Tak"
                          : isDL
                            ? "Delhi Tak"
                            : isCGT
                              ? "Chhattisgarh Tak"
                              : isUK
                                ? "Uttarakhand Tak"
                                : siteInfo?.siteName
              }
              width="92px"
              loading="eager"
              className={`${isMadhya
                ? "w-[90px]"
                : isRajasthan
                  ? "w-[130px]"
                  : isHR
                    ? "w-[120px]"
                    : isBH
                      ? "w-[100px]"
                      : isDL
                        ? "w-[120px]"
                        : isUP
                          ? "w-[90px]"
                          : isCGT
                            ? "w-[120px]"
                            : isUK
                              ? "w-[124px]"
                              : "w-[110px]"
                }`}
            />
          </a>
        </div>

        {/* Desktop menu */}
        <div
          className={`right-0 bg-white w-full md:static md:flex ms-5 divide-x divide-slate-300 md:w-[63%]`}
        >
          <Navlink
            exact={true}
            className={`flex items-center px-4  ${router?.asPath === "/" ? "text-primary" : ""
              } ${isRajasthan
                ? "hover:text-rajasthanDark"
                : isMadhya
                  ? "hover:text-mpDark"
                  : isHR
                    ? "hover:text-hrDark"
                    : isBH
                      ? "hover:text-biharDark"
                      : isUP
                        ? "hover:text-upDark"
                        : isCGT
                          ? "hover:text-mpDark"
                          : isUK
                            ? "hover:text-ukDark"
                            : isBiz ? "hover:text-bizDark"
                            : "hover:text-primary"
              } min-w-[100px]`}
            href={'/'}
            title={textLanguage?.headerStaticMenuText?.home}
            onClick={() => {
              let eventName = `TopBar-Home`;
              sendGAEvent({
                eventName: eventName,
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            {/* <SVG
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/home.svg"
              className="h-6 w-6 mr-2"
              title="home"
            /> */}
            <svg fill="none" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2"><title>home</title><g fill="currentColor"><path d="m9.5 17.5c-.27614 0-.5.2239-.5.5s.22386.5.5.5h5c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5z"></path><path clipRule="evenodd" d="m14.1688 2.57514c-1.2716-1.00388-3.066-1.00388-4.33756 0l-6.5 5.13158c-.84073.66374-1.33124 1.67592-1.33124 2.74708v8.0462c0 1.933 1.567 3.5 3.5 3.5h13c1.933 0 3.5-1.567 3.5-3.5v-8.0462c0-1.07116-.4905-2.08334-1.3312-2.74708zm-3.7179.78488c.9083-.71706 2.1899-.71706 3.0982 0l6.5 5.13158c.6005.4741.9509 1.19709.9509 1.9622v8.0462c0 1.3807-1.1193 2.5-2.5 2.5h-13c-1.38071 0-2.5-1.1193-2.5-2.5v-8.0462c0-.76511.35036-1.4881.95089-1.9622z" fillRule="evenodd"></path></g></svg>
            {textLanguage?.headerStaticMenuText?.home}
          </Navlink>
          <Navlink
            className={`flex items-center px-4  ${router?.asPath?.includes("-livetv") ? "text-primary" : ""
              } ${isRajasthan
                ? "hover:text-rajasthanDark"
                : isMadhya
                  ? "hover:text-mpDark"
                  : isHR
                    ? "hover:text-hrDark"
                    : isBH
                      ? "hover:text-biharDark"
                      : isUP
                        ? "hover:text-upDark"
                        : isCGT
                          ? "hover:text-mpDark"
                          : isUK
                            ? "hover:text-ukDark"
                            : isBiz
                              ? "hover:text-bizDark"
                            : "hover:text-primary"
              } min-w-[100px]`}
            // className="flex items-center px-4 hover:text-primary min-w-[100px]"
            // href={process.env.NEXT_PUBLIC_VISUALSTORY_URL}
            // role="button"
            title={textLanguage?.headerStaticMenuText?.liveTV}
            href={liveKeys?.activeUrl || "/tak360-livetv"}
            exact={true}
            onClick={() => {
              let eventName = `TopBar-ReadClick`;
              sendGAEvent({
                eventName: eventName,
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <div className="min-w-[25px]">
              {/* <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/livetv.svg"
                className="h-6 w-6 mr-2"
                title="livetv"
              /> */}
              <svg width="43" height="38" viewBox="0 0 43 31" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2"><title>livetv</title><g clip-path="url(#clip0_6627_80163)"><path d="M37.5695 21.8228L34.4138 19.6093V12.4466L37.5695 10.2331C39.1133 9.1547 40.3846 9.81308 40.3846 11.7088V20.3585C40.3846 22.2542 39.1133 22.9126 37.5695 21.8228Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.1589 2.85524V6.55534C12.1589 7.31314 13.0608 7.7887 13.7806 7.4098L15.5377 6.48574L17.2948 5.55782C18.0146 5.17892 18.0146 4.23166 17.2948 3.85276L15.5377 2.92483L13.7806 2.00077C13.0608 1.62187 12.1589 2.09357 12.1589 2.85524Z" fill="currentColor"></path><path d="M12.4492 18.3568V19.6538H8.38646V18.3568H12.4492ZM8.9241 11.5837V19.6538H7.2613V11.5837H8.9241ZM15.1707 11.5837V19.6538H13.5134V11.5837H15.1707ZM19.6381 17.9688L21.5392 11.5837H23.3904L20.5803 19.6538H19.3609L19.6381 17.9688ZM17.8866 11.5837L19.7822 17.9688L20.0704 19.6538H18.8399L16.0464 11.5837H17.8866ZM29.5594 18.3568V19.6538H25.2639V18.3568H29.5594ZM25.807 11.5837V19.6538H24.1442V11.5837H25.807ZM28.9996 14.8705V16.1342H25.2639V14.8705H28.9996ZM29.5539 11.5837V12.8862H25.2639V11.5837H29.5539Z" stroke="currentColor" fill="none"></path><path d="M20.3321 4.7041H29.1881C32.0092 4.7041 34.2962 6.99108 34.2962 9.81222V22.0907C34.2962 24.9119 32.0093 27.1988 29.1881 27.1988H7.62057C4.79943 27.1988 2.51245 24.9118 2.51245 22.0907V9.81221C2.51245 6.99108 4.79943 4.7041 7.62057 4.7041L9.89083 4.7041" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_6627_80163"><rect width="41.7202" height="26.8864" fill="white" transform="translate(0.55957 1.87256)"></rect></clipPath></defs></svg>
            </div>
            {textLanguage?.headerStaticMenuText?.liveTV}
          </Navlink>
          <Navlink
            className={`flex items-center px-4
               ${router?.asPath?.includes("/stories") ? "text-primary" : ""}
               ${isRajasthan
                ? "hover:text-rajasthanDark"
                : isMadhya
                  ? "hover:text-mpDark"
                  : isHR
                    ? "hover:text-hrDark"
                    : isBH
                      ? "hover:text-biharDark"
                      : isUP
                        ? "hover:text-upDark"
                        : isCGT
                          ? "hover:text-mpDark"
                          : isUK
                            ? "hover:text-ukDark"
                            : isBiz ? "hover:text-bizDark"
                            : "hover:text-primary"
              } min-w-[100px]`}
            // className="flex items-center px-4 hover:text-primary min-w-[100px]"
            // href={process.env.NEXT_PUBLIC_VISUALSTORY_URL}
            // role="button"
            title={textLanguage?.headerStaticMenuText?.read}
            href={"/stories"}
            exact={true}
            onClick={() => {
              let eventName = `TopBar-ReadClick`;
              sendGAEvent({
                eventName: eventName,
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <div className="min-w-[25px]">
              {/* <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/read.svg"
                className="h-6 w-6 mr-2"
                title="webstories"
              /> */}
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2"><title>webstories</title><path d="M58.6673 26.6666V40C58.6673 53.3333 53.334 58.6667 40.0007 58.6667H24.0007C10.6673 58.6667 5.33398 53.3333 5.33398 40V24C5.33398 10.6666 10.6673 5.33331 24.0007 5.33331H37.334" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M58.6673 26.6666H48.0007C40.0007 26.6666 37.334 24 37.334 16V5.33331L58.6673 26.6666Z" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.666 34.6667H34.666" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.666 45.3333H29.3327" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </div>
            {textLanguage?.headerStaticMenuText?.read}
          </Navlink>

          <Navlink
            className={`flex items-center px-4  ${router?.asPath?.includes("/videos") ? "text-primary" : ""
              }  ${isRajasthan
                ? "hover:text-rajasthanDark"
                : isMadhya
                  ? "hover:text-mpDark"
                  : isHR
                    ? "hover:text-hrDark"
                    : isBH
                      ? "hover:text-biharDark"
                      : isUP
                        ? "hover:text-upDark"
                        : isCGT
                          ? "hover:text-mpDark"
                          : isUK
                            ? "hover:text-ukDark"
                            : isBiz ? "hover:text-bizDark"
                            : "hover:text-primary"
              } min-w-[102px]`}
            href={"/videos"}
            title={textLanguage?.headerStaticMenuText?.watch}
            onClick={() => {
              let eventName = `TopBar-WatchClick`;
              sendGAEvent({
                eventName: eventName,
                pageTitle: document?.title,
                pageLocation: window?.location?.href,
              });
            }}
          >
            <div className="min-w-[25px]">
              {/* <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/video.svg"
                className="h-6 w-6 mr-2"
                title="videos"
              /> */}
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2"><title>videos</title><path d="M45.8337 31.25V18.75C45.8337 8.33333 41.667 4.16667 31.2503 4.16667H18.7503C8.33366 4.16667 4.16699 8.33333 4.16699 18.75V31.25C4.16699 41.6667 8.33366 45.8333 18.7503 45.8333H31.2503C41.667 45.8333 45.8337 41.6667 45.8337 31.25Z" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.25 14.8125H44.75" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.75 4.39583V14.5208" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M32.25 4.39583V13.5833" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20.3125 30.1042V27.6042C20.3125 24.3958 22.5833 23.0833 25.3542 24.6875L27.5208 25.9375L29.6875 27.1875C32.4583 28.7917 32.4583 31.4167 29.6875 33.0208L27.5208 34.2708L25.3542 35.5208C22.5833 37.125 20.3125 35.8125 20.3125 32.6042V30.1042V30.1042Z" stroke="currentColor" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </div>
            {textLanguage?.headerStaticMenuText?.watch}
          </Navlink>
          <div className="relative group z-[9999] ">
            <Navlink
              className={`flex items-center px-4
      ${router?.asPath?.includes("/state-news") ? "text-primary" : ""} ${isRajasthan
                  ? "hover:text-rajasthanDark"
                  : isMadhya
                    ? "hover:text-mpDark"
                    : isHR
                      ? "hover:text-hrDark"
                      : isBH
                        ? "hover:text-biharDark"
                        : isUP
                          ? "hover:text-upDark"
                          : isCGT
                            ? "hover:text-mpDark"
                            : isUK
                              ? "hover:text-ukDark"
                              : isBiz
                                ? "hover:text-bizDark"
                              : "hover:text-primary"
                } min-w-[110px]`}
              role="button"
              href={"/state-news"}
              title={"राज्य"}
              onClick={() => {
                let eventName = `TopBar-stateNewsClick`;
                sendGAEvent({
                  eventName: eventName,
                  pageTitle: document?.title,
                  pageLocation: window?.location?.href,
                });
              }}
            >
              <div className="min-w-[25px] my-3">
                {/* <SVG
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/global-search.svg"
                  className="h-6 w-6 mr-2"
                  title="state news"
                /> */}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2"><title>state news</title><g id="vuesax/linear/global-search"><g id="global-search"><g id="Group"><path id="Vector" d="M18.3337 10.0001C18.3337 5.40008 14.6003 1.66675 10.0003 1.66675C5.40033 1.66675 1.66699 5.40008 1.66699 10.0001C1.66699 14.6001 5.40033 18.3334 10.0003 18.3334" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path id="Vector_2" d="M6.66667 2.5H7.5C5.875 7.36667 5.875 12.6333 7.5 17.5H6.66667" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path id="Vector_3" d="M12.5 2.5C13.3083 4.93333 13.7167 7.46667 13.7167 10" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path id="Vector_4" d="M2.5 13.3333V12.5C4.93333 13.3083 7.46667 13.7167 10 13.7167" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path id="Vector_5" d="M2.5 7.5C7.36667 5.875 12.6333 5.875 17.5 7.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></g><g id="Group_2"><path id="Vector_6" d="M15.1667 17.8334C16.6394 17.8334 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8334 15.1667 17.8334Z" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path id="Vector_7" d="M18.3333 18.3333L17.5 17.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></g></g></g></svg>
              </div>
              राज्य
            </Navlink>

            {/* Dropdown */}
            <div className="absolute top-full w-[160px] left-0 hidden group-hover:block bg-white border rounded-sm shadow-md z-[9999]">
              {stateMenus &&
                stateMenus?.sub_menu.map((state) => (
                  <a
                    key={state.title}
                    href={websiteUrl + state.canonical_url}
                    className={`flex items-center px-4 py-2   border-b last:border-b-0 ${isMadhya
                      ? "hover:bg-[#e2f8f4] group"
                      : isRajasthan
                        ? "hover:bg-[#faf2e7] group"
                        : isHR
                          ? "hover:bg-[#e8fce1] group"
                          : isBH
                            ? "hover:bg-[#ffe2f4] group"
                            : isUP
                              ? "hover:bg-[#feedeb] group"
                              : isDL
                                ? "hover:bg-[#fbd6d6] group"
                                : isCGT
                                  ? "hover:bg-[#e0faf5] group"
                                  : isUK
                                    ? "hover:bg-[#e2f1fa] group"
                                    : isBiz ? "hover:bg-bizDark group"  
                                    : "hover:bg-primary-300 group"
                      }`}
                  >
                    {state.title}
                  </a>
                ))}
            </div>
          </div>

          {/* 
          <Navlink
            className="flex items-center px-4 hover:text-primary min-w-[96px]"
            href="/business"
            title={textLanguage?.headerStaticMenuText?.business}
          >
            <div className="min-w-[25px]">
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/world.svg"
                className="h-6 w-6 mr-2 "
                title="shorts"
              />
            </div>
            {textLanguage?.headerStaticMenuText?.business}
          </Navlink>

          <Navlink
            className="flex items-center px-4 hover:text-primary min-w-[96px]"
            href="/short-videos"
            title={textLanguage?.headerStaticMenuText?.shorts}
          >
            <div className="min-w-[25px]">
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/video-clip.svg"
                className="h-6 w-6 mr-2"
                title="shorts"
              />
            </div>
            {textLanguage?.headerStaticMenuText?.shorts}
          </Navlink> */}
        </div>
        {(isRajasthan ||
          isMadhya ||
          isHR ||
          isBH ||
          isUP ||
          isDL ||
          isCGT ||
          isUK ||
          isBiz
        ) && (
            <a
              className={`text-black flex items-center px-4 w-[20%] font-semibold min-w-[126px]`}
              // href={process.env.NEXT_PUBLIC_VISUALSTORY_URL}
              role="button"
              href={websiteUrl}
              title="Back to NewsTak"
            >
              <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/left.svg" />
              <span className="mx-1 whitespace-nowrap">Back To </span>
              <div className="min-w-[25px]">
                <img
                  src={siteInfo.siteLogo}
                  className="h-6 w-18 mr-2"
                  title="Back to NewsTak"
                  alt="Back to NewsTak"
                  loading="eager"
                />
              </div>
            </a>
          )}
        <div
          className={`absolute top-0 right-0 bg-white z-50 w-full md:static md:flex md:items-center md:w-[25%]`}
        >
          {/* Search Bar */}
          <div className="flex items-center mx-auto w-[90%]">
            <div className="relative w-full">
              <input
                id="search"
                className={`${styles.searchInput} placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:border-primary-300 focus:ring-primary-300 focus:ring-1 sm:text-sm`}
                placeholder="यहां खोज करें"
                type="text"
                name="search"
                value={searchText}
                onKeyDown={handleKeyPress}
                minLength={1}
                onChange={(e) => setSearchText(e?.target?.value)}
              />
              <div
                className="absolute inset-y-0 right-0 flex items-center pr-3"
                onClick={() => handleSearch()}
              >
                <img
                  className="text-gray-500"
                  loading="eager"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/search.svg"
                  alt="Search Icon"
                  height={20}
                  width={20}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
